<template>
  <div class="asSupportNotAuth">
    <div class="asSupportNotAuth_title">
      {{ $t('forTechnicalQuestions') }}
    </div>
    <div class="asSupportNotAuth_content">
      <div class="asSupportNotAuth_text">
        {{ $t('pleaseContactEmail') }}
        <a
          :href="`mailto:${supportEmail}`"
          class="asSupportNotAuth_link"
        >
          {{ supportEmail }}
        </a>
      </div>
      <template v-if="whatsAppNumber">
        <div class="asSupportNotAuth_text -small">
          {{ $t('partsSpeech.or') }}
        </div>
        <div class="asSupportNotAuth_text">
          {{ $t('chattingWhatsApp') }}
        </div>
        <a
          :href="whatsAppNumber"
          target="_blank"
          class="asSupportNotAuth_text"
        >
          <div class="asSupportNotAuth_whatsApp">
            <div class="asSupportNotAuth_whatsApp_icon"/>
          </div>
        </a>
      </template>
    </div>
    <div class="asSupportNotAuth_footer">
      <div class="asSupportNotAuth_text -bold">
        {{ $t('weHelp') }}!
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, computed } from 'vue'

import { useStore } from '@web/store'

export default defineComponent({
  name: 'AsSupportNotAuth',
  setup () {
    const store = useStore()

    const whatsAppNumbers = {
      iqface: 'https://wa.me/79260214182',
      anyclass: 'https://wa.me/79252407332'
    }

    const projectTitle = computed<string>(() => store.getters['assets/projectTitle'])
    const supportEmail = computed<string>(() => store.getters['assets/supportEmail'])
    const whatsAppNumber = computed<string>(() => store.getters['assets/whatsAppNumber'] || whatsAppNumbers[projectTitle.value.toLowerCase()])

    return {
      supportEmail,
      whatsAppNumber
    }
  }
})
</script>

<style lang="scss" scoped>
  .asSupportNotAuth {
    padding: 48px 16px 40px;
    font-size: 16px;
    line-height: 24px;

    &_title {
      text-align: center;
    }

    &_content {
      margin: 30px 0;
      display: flex;
      flex-flow: column nowrap;
      align-items: center;
    }

    &_footer {
      display: flex;
      flex-flow: column nowrap;
      align-items: center;
    }

    &_whatsApp {
      width: 60px;
      height: 60px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 50%;
      background-color: #00E676;

      &_icon {
        display: block;
        width: 35px;
        height: 35px;
        background: url('~@web/assets/images/icon-whatsapp.svg') no-repeat;
        background-size: cover;
      }
    }

    &_text {
      margin-top: 8px;

      &:first-child {
        margin-top: 0;
      }

      &.-bold {
        font-size: 20px;
        font-weight: bold;
      }

      &.-small {
        text-transform: lowercase;
      }
    }

    &_link {
      text-decoration: none;
    }
  }
</style>
